import MatchedMap from 'utilities/src/matchedMap';
import { ButtonBGEnum } from '../../../types/_bg';

const buttonClassesMap = new MatchedMap([
  [
    ButtonBGEnum.Light,
    'bg-transparent border-transparent hover:border-current border-b-2 focus:border-transparent focus:shadow-v-ring active:shadow-none active:border-current',
  ],
  [
    ButtonBGEnum.Dark,
    'bg-transparent border-transparent hover:border-current border-b-2 focus:border-transparent focus:shadow-v-ring active:shadow-none active:border-current',
  ],
]);

const buttonDisabledClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'disabled:border-transparent disabled:text-site-neutrals-200'],
  [ButtonBGEnum.Dark, 'disabled:border-transparent disabled:text-site-neutrals-500'],
]);

const buttonSiteTextOnlyClasses = [buttonClassesMap, buttonDisabledClassesMap];

export default buttonSiteTextOnlyClasses;
